import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardService } from '../services/dashboard.service';

export const dashboardResolver = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const dashboardService = inject(DashboardService);
  let page = 1;

  if (route.queryParams['page']) {
    page = route.queryParams['page'];
  }

  let limit = 5;
  return dashboardService.getAnalyticsEventsTransactions$(limit).pipe(
    map(response => response.data),
    catchError(error => {
      router.navigate(['/dashboard']);
      console.error(error);
      return of([]);
    })
  );
};
